import React from "react";
import SickReasonsIcon from "../../../../components/Icons/SickReasonsIcon";

interface UrgentReasonCardProps {
  title: string;
  value: string;
  isSelected: boolean;
  onSelect: (value: string) => void;
}

export const UrgentReasonCard = ({
  title,
  value,
  isSelected,
  onSelect,
}: UrgentReasonCardProps) => (
  <div
    onClick={() => onSelect(value)}
    className={`capitalize cursor-pointer w-full rounded-lg border border-taupe-50
      p-4 flex flex-col gap-2 items-center bg-white transition-colors
      hover:bg-taupe-15
      ${isSelected ? "!bg-gv-yellow-light !border-gv-yellow" : ""}`}
  >
    <div className={`rounded-full p-2 ${isSelected ? "bg-gv-gold-1" : "bg-taupe-3"}`}>
      <SickReasonsIcon />
    </div>
    <div className="text-center text-sm font-semibold w-3/4 text-light-black">
      {title}
    </div>
  </div>
);
